(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leone-eye-exam-booking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const dateKey = (value = new Date()) => {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(value).map((part) => [part.type, part.value]));
      return `${parts.year}-${parts.month}-${parts.day}`;
    };
    const addDays = (value, count) => {
      const date = new Date(`${value}T12:00:00Z`);
      date.setUTCDate(date.getUTCDate() + count);
      return date.toISOString().slice(0, 10);
    };
    const weekMonday = (value) => {
      const date = new Date(`${value}T12:00:00Z`);
      const offset = (date.getUTCDay() + 6) % 7;
      date.setUTCDate(date.getUTCDate() - offset);
      return date.toISOString().slice(0, 10);
    };
    const interpolate = (template, values = {}) => Object.entries(values).reduce(
      (text, [key, value]) => text.replaceAll(`%{${key}}`, String(value)), String(template || '')
    );

    function initialize(root) {
      if (!root || root.dataset.leoneExamReady === 'true') return;
      root.dataset.leoneExamReady = 'true';
      const configNode = root.querySelector('[data-leone-exam-config]');
      let config;
      try { config = JSON.parse(configNode?.textContent || '{}'); } catch { config = {}; }
      const strings = config.strings || {};
      const hubUrl = String(config.hubUrl || '').replace(/\/$/, '');
      const locale = config.locale || 'fr-CA';
      const state = {days: [], page: 0, selectedDay: null, selectedSlot: null};
      const status = root.querySelector('[data-booking-status]');
      const calendar = root.querySelector('[data-booking-calendar]');
      const daysRoot = root.querySelector('[data-booking-days]');
      const slotsRoot = root.querySelector('[data-booking-slots]');
      const timesPanel = root.querySelector('[data-times-panel]');
      const form = root.querySelector('[data-booking-form]');
      const confirmation = root.querySelector('[data-booking-confirmation]');
      const formError = root.querySelector('[data-form-error]');
      const submit = form?.querySelector('button[type="submit"]');
      const submitLabel = root.querySelector('[data-submit-label]');
      const customerModeInput = form?.querySelector('[data-customer-mode-input]');
      const newCustomerFields = form?.querySelector('[data-new-customer-fields]');
      const emailInput = form?.querySelector('[name="email"]');
      const phoneInput = form?.querySelector('[name="phone"]');
      const formatLong = new Intl.DateTimeFormat(locale, {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'});
      const formatDay = new Intl.DateTimeFormat(locale, {weekday: 'short'});
      const formatMonth = new Intl.DateTimeFormat(locale, {month: 'short'});
      const displayDate = (value) => new Date(`${value}T12:00:00`);
      const longDate = (value) => formatLong.format(displayDate(value));
      const setCustomerMode = () => {
        if (customerModeInput) customerModeInput.value = 'existing';
        if (newCustomerFields) newCustomerFields.hidden = false;
        newCustomerFields?.querySelectorAll('input, select').forEach((field) => {
          field.disabled = false;
          field.required = true;
        });
        if (emailInput) emailInput.required = true;
        if (phoneInput) phoneInput.required = true;
        emailInput?.setCustomValidity('');
        phoneInput?.setCustomValidity('');
      };
      const setStep = (step) => {
        const order = ['date', 'time', 'details'];
        root.querySelectorAll('[data-step-indicator]').forEach((node) => {
          const index = order.indexOf(node.dataset.stepIndicator);
          const current = order.indexOf(step);
          node.classList.toggle('is-current', index === current);
          node.classList.toggle('is-complete', index < current);
        });
      };
      const setStatus = (message, error = false, retry = false) => {
        status.hidden = false;
        status.classList.toggle('is-error', error);
        status.replaceChildren();
        if (!error) {
          const spinner = document.createElement('span');
          spinner.className = 'leone-exam__spinner';
          spinner.setAttribute('aria-hidden', 'true');
          status.append(spinner);
        }
        const label = document.createElement('span');
        label.textContent = message;
        status.append(label);
        if (retry) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'leone-exam__secondary-button';
          button.textContent = strings.retry;
          button.addEventListener('click', loadAvailability, {once: true});
          status.append(button);
        }
      };
      const dayStatus = (day) => {
        if (day.past) return strings.past;
        if (!day.open) return strings.closed;
        if (!day.slots.length) return strings.full;
        return interpolate(day.slots.length === 1 ? strings.availableOne : strings.availableMany, {count: day.slots.length});
      };
      const renderSlots = () => {
        const day = state.selectedDay;
        slotsRoot.replaceChildren();
        if (!day) { timesPanel.hidden = true; return; }
        timesPanel.hidden = false;
        root.querySelector('[data-selected-day-label]').textContent = longDate(day.date);
        root.querySelector('[data-selected-day-hours]').textContent = `${day.start}–${day.end} · ${day.durationMinutes} ${strings.minutes}`;
        day.slots.forEach((slot) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'leone-exam__slot';
          button.textContent = slot.time;
          button.classList.toggle('is-selected', state.selectedSlot?.token === slot.token);
          button.setAttribute('aria-pressed', state.selectedSlot?.token === slot.token ? 'true' : 'false');
          button.addEventListener('click', () => {
            state.selectedSlot = slot;
            renderSlots();
            form.hidden = false;
            setStep('details');
            root.querySelector('[data-booking-summary]').textContent = interpolate(strings.bookingSummary, {date: longDate(day.date), time: slot.time});
            if (window.matchMedia('(max-width: 640px)').matches) form.scrollIntoView({behavior: 'smooth', block: 'start'});
          });
          slotsRoot.append(button);
        });
      };
      const renderDays = () => {
        const startIndex = state.page * 7;
        const visible = state.days.slice(startIndex, startIndex + 7);
        daysRoot.replaceChildren();
        visible.forEach((day) => {
          const date = displayDate(day.date);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'leone-exam__day';
          button.disabled = !day.open || !day.slots.length;
          button.classList.toggle('is-selected', state.selectedDay?.date === day.date);
          button.setAttribute('aria-pressed', state.selectedDay?.date === day.date ? 'true' : 'false');
          button.setAttribute('aria-label', `${longDate(day.date)} · ${dayStatus(day)}`);
          const weekday = document.createElement('span');
          weekday.className = 'leone-exam__day-weekday';
          weekday.textContent = formatDay.format(date).replace('.', '');
          const number = document.createElement('span');
          number.className = 'leone-exam__day-number';
          number.textContent = date.getDate();
          const month = document.createElement('span');
          month.className = 'leone-exam__day-status';
          month.textContent = `${formatMonth.format(date).replace('.', '')} · ${dayStatus(day)}`;
          const compactStatus = document.createElement('span');
          compactStatus.className = 'leone-exam__day-compact-status';
          compactStatus.textContent = day.open && day.slots.length ? String(day.slots.length) : '—';
          compactStatus.setAttribute('aria-hidden', 'true');
          button.append(weekday, number, month, compactStatus);
          if (day.open && day.start && day.end) {
            const hours = document.createElement('span');
            hours.className = 'leone-exam__day-hours';
            hours.textContent = `${day.start}–${day.end}`;
            button.append(hours);
          }
          if (day.exception) {
            const badge = document.createElement('span');
            badge.className = 'leone-exam__day-exception';
            badge.textContent = strings.exception;
            button.append(badge);
          }
          button.addEventListener('click', () => {
            state.selectedDay = day;
            state.selectedSlot = null;
            form.hidden = true;
            confirmation.hidden = true;
            setStep('time');
            renderDays();
            renderSlots();
          });
          daysRoot.append(button);
        });
        const first = visible[0]?.date;
        const last = visible[visible.length - 1]?.date;
        root.querySelector('[data-week-label]').textContent = first && last
          ? interpolate(strings.weekRange, {from: longDate(first), to: longDate(last)}) : '';
        root.querySelector('[data-week-previous]').disabled = state.page === 0;
        root.querySelector('[data-week-next]').disabled = startIndex + 7 >= state.days.length;
      };
      const loadAvailability = async () => {
        if (!hubUrl) {
          setStatus(strings.configurationError, true, false);
          return;
        }
        calendar.hidden = true;
        form.hidden = true;
        confirmation.hidden = true;
        setStatus(strings.loading);
        const from = weekMonday(dateKey());
        const to = addDays(from, 41);
        try {
          const response = await fetch(`${hubUrl}/api/public/appointments/availability?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`, {
            method: 'GET', mode: 'cors', credentials: 'omit', headers: {'Accept': 'application/json'}
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data.error || strings.loadError);
          state.days = Array.isArray(data.days) ? data.days : [];
          state.page = 0;
          state.selectedDay = state.days.slice(0, 7).find((day) => day.open && day.slots?.length) || null;
          state.selectedSlot = null;
          status.hidden = true;
          calendar.hidden = false;
          setStep(state.selectedDay ? 'time' : 'date');
          renderDays();
          renderSlots();
        } catch (error) {
          setStatus(error.message || strings.loadError, true, true);
        }
      };
      root.querySelector('[data-week-previous]')?.addEventListener('click', () => {
        if (state.page > 0) {
          state.page -= 1;
          state.selectedDay = state.days.slice(state.page * 7, state.page * 7 + 7).find((day) => day.open && day.slots?.length) || null;
          state.selectedSlot = null;
          form.hidden = true;
          setStep(state.selectedDay ? 'time' : 'date');
          renderDays(); renderSlots();
        }
      });
      root.querySelector('[data-week-next]')?.addEventListener('click', () => {
        if ((state.page + 1) * 7 < state.days.length) {
          state.page += 1;
          state.selectedDay = state.days.slice(state.page * 7, state.page * 7 + 7).find((day) => day.open && day.slots?.length) || null;
          state.selectedSlot = null;
          form.hidden = true;
          setStep(state.selectedDay ? 'time' : 'date');
          renderDays(); renderSlots();
        }
      });
      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        formError.hidden = true;
        emailInput?.setCustomValidity('');
        phoneInput?.setCustomValidity('');
        if (!form.reportValidity() || !state.selectedDay || !state.selectedSlot) {
          formError.textContent = strings.requiredError;
          formError.hidden = false;
          return;
        }
        const fields = new FormData(form);
        const payload = Object.fromEntries(fields.entries());
        payload.slotToken = state.selectedSlot.token;
        payload.consent = fields.get('consent') === 'on';
        submit.disabled = true;
        submitLabel.textContent = strings.booking;
        try {
          const requestBooking = async (customerMode) => {
            const requestPayload = {...payload, customerMode};
            const response = await fetch(`${hubUrl}/api/public/appointments/book`, {
              method: 'POST', mode: 'cors', credentials: 'omit',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(requestPayload)
            });
            const data = await response.json().catch(() => ({}));
            return {response, data};
          };
          let result = await requestBooking('existing');
          if (!result.response.ok && result.response.status === 404) result = await requestBooking('new');
          const {response, data} = result;
          if (!response.ok) throw new Error(response.status >= 500 ? strings.bookingError : (data.error || strings.bookingError));
          if (data?.ok !== true || !data?.confirmation?.date || !data?.confirmation?.time) throw new Error(strings.bookingError);
          calendar.hidden = true;
          form.hidden = true;
          confirmation.hidden = false;
          root.querySelector('[data-confirmation-summary]').textContent = interpolate(strings.confirmationSummary, {
            date: longDate(data.confirmation.date), time: data.confirmation.time
          });
          setStep('details');
          confirmation.focus();
        } catch (error) {
          formError.textContent = error.message || strings.loadError;
          formError.hidden = false;
        } finally {
          submit.disabled = false;
          submitLabel.textContent = strings.reserve;
        }
      });
      root.querySelector('[data-book-another]')?.addEventListener('click', () => {
        form.reset();
        setCustomerMode('existing');
        const language = form.querySelector('[name="locale"]');
        if (language) language.value = ['fr', 'en', 'es'].includes(locale.slice(0, 2)) ? locale.slice(0, 2) : 'fr';
        loadAvailability();
      });
      const language = form?.querySelector('[name="locale"]');
      if (language) language.value = ['fr', 'en', 'es'].includes(locale.slice(0, 2)) ? locale.slice(0, 2) : 'fr';
      const birthDate = form?.querySelector('[name="birthDate"]');
      if (birthDate) birthDate.max = dateKey();
      setCustomerMode('existing');
      loadAvailability();
    }

    document.querySelectorAll('[data-leone-exam]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-leone-exam]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
